module.exports = __webpack_public_path__ + "media/images/countrysquared/na-3cb13da20ac2d5df87e1745c8e4cbd29.svg";